<template>
    <div class="policyDetail">
        <div class="Con-policyDetail">
            <el-breadcrumb class="tip" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/policy' }">政策</el-breadcrumb-item>
                <el-breadcrumb-item>政策详情</el-breadcrumb-item>
            </el-breadcrumb>

            <article-detail :artDetail='Detail' :pageType="pageType"></article-detail>

            <return-top></return-top>
        </div>
    </div>
</template>

<script>
import ArticleDetail from '@/components/information/articleDetail.vue'
import ReturnTop from '@/components/returnTop.vue'
export default {
  name: 'policyDetail',
  props: {

  },
  components: {
    ArticleDetail,
    ReturnTop

  },
  data () {
    return {
      pageType: 'policy',
      Detail: {
        title: '广州市引进人才入户管理办法',
        time: '发文时间：2018-12-04',
        from: '穗府办规',
        code: '〔2018〕30号',
        reader: '阅读137',
        content: '第一条 为进一步优化人口结构，推进实施人才强市战略，大力集聚优质人才，根据国家、省有关法律、法规和《广州市户籍迁入管理规定》等规定制定本办法。第二条 本办法所称的引进人才入户，是指在年龄、学历、职称、技能、岗位等方面符合条件，在本市就业或创业的人才入户广州，包括用人单位接收普通高校应届毕业生和引进在职人才入户广州。第三条 引进人才入户坚持突出高端、以用为本、规范管理、方便快捷的原则，优先满足本市战略性主导产业、重点发展产业、总部企业以及其他鼓励发展的产业所需人才的入户需求。第四条 市发展改革部门负责将引进人才入户指标统一纳入全市年度迁入人口计划内管理。组织部门按分工做好高层次人才的认定工作，按职能进行相关人员引进人才入户的审核办理。市人力资源和社会保障部门负责引进人才工作的统筹协调以及市属用人单位引进人才入户的组织实施；对各区人力资源和社会保障部门引进人才工作进行业务指导和监督检查；审核确认本市高技能人才；会同市发展改革委制定我市引进技术技能人才职业目录；承接省相关部门下放的引进人才入户审核事项。各区人力资源和社会保障部门负责住所地址在本行政区内的用人单位引进人才入户的组织实施。市、区公安机关负责普通高校应届毕业生的入户审核和办理。省直及中央驻穗用人单位引进人才及其入户指标按职责分工由省发展改革部门统筹协调及管理；省直及中央驻穗用人单位引进在职人才（包括国〔境〕外留学人员）入户由省人力资源和社会保障部门按职责分工审核办理。其他有关部门按各自职能配合做好相关工作。第五条 符合下列条件之一，来本市创业或就业的人员，可申请将户籍迁入本市。（一）经我市认定或审核确认的高层次、高技能人才，包括：1．中国科学院或中国工程院院士，年龄不受限制。2．享受国务院特殊津贴人员，国家海外高层次人才引进计划入选者，国家“特支计划”专家，国家最高科学技术奖、国际科学技术合作奖获得者，国家自然科学奖、国家技术发明奖、国家科学技术进步奖、国家最高科学技术奖获奖人员或项目主要完成人，“长江学者”特聘教授，全国杰出专业技术人才，“百千万人才工程”国家级人选，国家、省（部）级有突出贡献中青年专家，国家重点学科、重点实验室学术技术带头人，“中华技能大奖”获得者，全国技术能手，世界技能大赛获奖选手及被确定为世界技能大赛中国参赛集训选手的人员，年龄不受限制。3．“珠江人才计划”创新创业团队带头人及核心成员，“广东省培养高层次人才特殊支持计划”、南粤突出贡献和创新奖获得者等省级人才工程入选者，年龄不受限制。4．广州市杰出专家、优秀专家、青年后备人才，广州市“百人计划”入选者，广州市产业领军人才，以及省、市认定的其他高层次、高技能人才，年龄需在50周岁以下。5．上年度或当年度获国家、省级、市级“劳动模范”“广东省技术能手”等称号的人员，以及在市级一类技能竞赛中取得前三名或在市级二类技能竞赛中取得第一名的人员，年龄需在45周岁以下。',
        img: require('@/assets/home/slideshow.png')
      }
    }
  },
  computed: {

  },
  created () {
    this.getPolicyDetail()
  },
  mounted () {
    document.documentElement.scrollTop = 0

    this.$parent.activeIndex = '9'
  },
  methods: {
    // 获取政策详情数据
    async getPolicyDetail () {
      // const dataDetail = JSON.parse(sessionStorage.getItem('detailData'))
      // this.Detail = dataDetail

      const res = await this.$get(this.$url.policy.policyDetail, {
        id: this.$route.query.id
      })

      const { code, msg, data } = res.data
      if (code === 200) {
        this.Detail = data
        // console.log(data)
      } else {
        this.$message.error(msg)
      }
    }
  }
}
</script>

<style scoped lang="less">
.policyDetail{
    width:100%;
    min-height: 90vh;
    background-color: #F5F5F5;
    overflow: hidden;
    margin-top: 7px;
}
.Con-policyDetail{
    min-height: 813px;
    width: 1200px;
    margin: 0 auto;
    background-color: #fff;
    box-sizing: border-box;
    margin: 13px auto 100px;
    padding-top: 28px;
    border-radius: 8px;
    .tip{
        margin-left: 12px;
    }
    /deep/.el-breadcrumb__inner{
        color: #3f62da  !important;
    }
    /deep/.is-link{
        color: #000 !important;
        text-decoration: underline;
    }
}
</style>
